import { useTranslation } from 'react-i18next';
import { useDashboard } from '@/hooks/queries/useDashboard';

function dispatchKey(key: string, options: { meta?: boolean } = {}) {
  const event = new KeyboardEvent('keydown', {
    key,
    metaKey: options.meta ?? false,
    ctrlKey: options.meta ?? false,
    bubbles: true,
  });
  document.dispatchEvent(event);
}

export function StatusBar() {
  const { t } = useTranslation('dashboard');
  const { data } = useDashboard('1d');

  const teamCount = data?.summary.active_employees ?? 0;
  const version = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.27.0';
  const openTime = new Intl.DateTimeFormat('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date());

  const kbdClass =
    'rounded border border-slate-900/[0.07] bg-slate-100 px-1.5 py-0.5 font-mono text-[10px] text-slate-700 dark:border-white/[0.06] dark:bg-charcoal-800 dark:text-slate-300';

  return (
    <footer className="hidden h-7 shrink-0 items-center gap-4 border-t border-slate-900/[0.07] bg-white px-4 font-mono text-[11px] text-slate-600 dark:border-white/[0.06] dark:bg-charcoal-900 dark:text-slate-300 lg:flex">
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={() => dispatchKey('k', { meta: true })}
          className="inline-flex cursor-pointer items-center gap-1.5 transition-colors hover:text-slate-700 dark:hover:text-slate-200"
        >
          <kbd className={kbdClass}>⌘K</kbd>
          {t('status_search', { defaultValue: 'Rechercher' })}
        </button>
        <span className="inline-flex items-center gap-1.5">
          <kbd className={kbdClass}>⌘N</kbd>
          {t('status_new_sale', { defaultValue: 'Nouvelle vente' })}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <kbd className={kbdClass}>?</kbd>
          {t('status_help', { defaultValue: 'Aide' })}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <kbd className={kbdClass}>G</kbd>
          {t('status_goto', { defaultValue: '+ lettre · go to' })}
        </span>
      </div>

      <div className="ml-auto flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5">
          <span
            aria-hidden
            className="size-1.5 animate-pulse rounded-full bg-lime-400 shadow-[0_0_6px_rgba(163,230,53,0.6)]"
          />
          {t('status_register_open', { defaultValue: 'Caisse ouverte' })} · {openTime}
        </span>
        <span aria-hidden>·</span>
        <span>
          {t('status_employees_count', {
            count: teamCount,
            defaultValue: `${teamCount} en poste`,
          })}
        </span>
        <span aria-hidden>·</span>
        <span>v{version}</span>
      </div>
    </footer>
  );
}
